/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M7.676,10.014 C8.456,9.233 8.456,7.967 7.676,7.186 L5.554,5.064 C4.773,4.283 3.507,4.283 2.726,5.064 L1.562,6.228 C0.553,7.237 0.396,8.812 1.184,10.002 C4.565,15.113 9.074,19.622 14.184,23.002 C15.372,23.788 16.951,23.631 17.958,22.623 L19.121,21.46 C19.903,20.679 19.903,19.412 19.121,18.632 L17.001,16.511 C16.22,15.73 14.953,15.73 14.172,16.511 L13.465,17.218 C11.138,15.311 8.875,13.047 6.969,10.721 L7.676,10.014 Z" />
      <polyline points="10.959 3.701 13.246 6.436 15.875 4.014" />
      <path d="M13.249,6.436 C12.987,2.982 15.354,0.607 18.185,0.502 C21.014,0.398 23.393,2.607 23.497,5.438 C23.601,8.269 21.392,10.646 18.561,10.75" />
    </g>
  </svg>
);

export default Icon;
